import React, { useLayoutEffect, useState } from "react";
import SUK from "./SUK/risk";
import Default from "./Default";
import MandG from "./MandG/index";
import { custom1, custom2, custom4 } from "../../../Utils/static-strings";
const Index = (props) => {
  const [currentSkin, setCurrentSkin] = useState(null);
  useLayoutEffect(() => {
    if (props.skin) {
      setCurrentSkin(props.skin);
    }
  }, []);

  const handleSkin = () => {
    switch (sessionStorage.getItem("skinName")) {
      case custom1:
        return <SUK {...props} />;
      case custom2:
      case custom4:
        return <MandG {...props} />;
      default:
        return <Default {...props} />;
    }
  };
  return (
    <React.Fragment>{currentSkin !== null && handleSkin()}</React.Fragment>
  );
};
export default Index;
